import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  constructor() {
    // TODO: pre load data
    // this.moveService.moves$
    //   .subscribe(result => {
    //     if (result.length <= 0) {
    //       this.moveService.getData('Active');
    //     }
    //   });
  }
}
